import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { 
  Box, Typography, Button, Paper, FormControlLabel, Checkbox, 
  TextField, Radio, RadioGroup, FormControl, Divider,
} from '@mui/material';
import { courseService, learningPathService } from '../../services/api';
import { useToast } from '../../context/ToastContext';
import { useUser } from '../../context/UserContext';
import PageTabs from '../shared/PageTabs';
import { buildCourseTabs, buildLPathTabs } from '../shared/tabConfigs';
const DefaultFeedbackSettings = ({ isLearningPath = false }) => {
  const { id } = useParams();
  const { showToast } = useToast();
  const { user } = useUser();
  const tabs = isLearningPath
    ? buildLPathTabs(id, { permissions: user?.permissions || [], roleId: user?.role_id })
    : buildCourseTabs(id, { permissions: user?.permissions || [], roleId: user?.role_id });
  //const [loading, setLoading] = useState(false);
  const [settings, setSettings] = useState({
    enabled: false,
    questionRequirement: 'first',
    question1: '',
    question2: '',
    q1Mandatory: false,
    q2Mandatory: false,
    showImmediate: false
  });
  
  const [itemTitle, setItemTitle] = useState('');
  const [q1CharsLeft, setQ1CharsLeft] = useState(200);
  const [q2CharsLeft, setQ2CharsLeft] = useState(200);
  const [isDirty, setIsDirty] = useState(false);
  
  useEffect(() => {
    loadFeedbackSettings();
  }, [id]);
  
  useEffect(() => {
    setQ1CharsLeft(200 - (settings.question1?.length || 0));
    setQ2CharsLeft(200 - (settings.question2?.length || 0));
  }, [settings.question1, settings.question2]);
  
  const loadFeedbackSettings = async () => {
    try {
      //setLoading(true);
      const response = await courseService.getCourseFeedbackSettings(id, isLearningPath);
      
      if (response.data && response.data.settings) {
        const data = response.data.settings;
        setSettings({
          enabled: data.enabled === 1,
          questionRequirement: data.question_requirement || 'first',
          question1: data.question1 || '',
          question2: data.question2 || '',
          q1Mandatory: data.question1_mandatory === 1,
          q2Mandatory: data.question2_mandatory === 1,
          showImmediate: data.show_immediate === 1
        });
        
        if (response.data.itemTitle) {
          setItemTitle(response.data.itemTitle);
        }
      }
    } catch (error) {
      console.error("Error loading feedback settings:", error);
      showToast('Failed to load feedback settings', 'error');
    }
  };
  
  /*
  const handleChange = (field, value) => {
    setSettings(prev => {
      const newSettings = {
        ...prev,
        [field]: value
      };
      setIsDirty(true);
      return newSettings;
    });
  };
  
  const handleSave = async () => {
    //setLoading(true);
    try {
      await courseService.saveCourseFeedbackSettings(id, settings, isLearningPath);
      showToast('Feedback settings saved successfully', 'success');
      setIsDirty(false);

    } catch (error) {
      console.error("Error saving feedback settings:", error);
      showToast('Failed to save feedback settings', 'error');
    } 
    // finally {
    //   setLoading(false);
    // }
  };
  */
  const handleToggleEnabled = async (checked) => {
    const newSettings = { ...settings, enabled: checked };
    setSettings(newSettings);
    setIsDirty(false);

    try {
      await courseService.saveCourseFeedbackSettings(id, newSettings, isLearningPath);
      showToast('Feedback settings saved successfully', 'success');
    } catch (error) {
      console.error("Error saving feedback settings:", error);
      showToast('Failed to save feedback settings', 'error');
      // Revert to server state on failure
      loadFeedbackSettings();
    }
  };
  
  return (
    <Box sx={{ p: 2 }}>
      <PageTabs tabs={tabs} />      
      <Box sx={{ display: 'flex', mb: 2 }}>
        <Typography variant="h4" gutterBottom>
          {isLearningPath ? 'Learning Path' : 'Course'} Settings
        </Typography>
      </Box>
      
      <Paper elevation={1} sx={{ p: 2, mb: 2, pt:1 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <Typography variant="h6">
            Enable Feedback
          </Typography>
          {/* <Button 
            variant="contained" 
            onClick={handleSave}
            disabled={!isDirty}
          >
            Save
          </Button> */}
        </Box>
        
        <Divider sx={{ mb: 2 }} />
        
        <Box sx={{ mt: 2 }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={settings.enabled}
                onChange={(e) => handleToggleEnabled(e.target.checked)}
              />
            }
            label="Enable Feedback"
          />
          <Typography variant="body2" color="textSecondary" sx={{ ml: 4, mb: 1 }}>
            A set of predefined questions for the Learner on completing the Course. You can manage this from Admin - Settings - Feedback.
          </Typography>
          
          {/* {settings.enabled && (
            <Box sx={{ mt: 3 }}>
              <Typography variant="body1" gutterBottom>
                Feedback Questions
              </Typography>
              
              <FormControl component="fieldset" sx={{ mb: 2 }}>
                <RadioGroup
                  value={settings.questionRequirement}
                  onChange={(e) => handleChange('questionRequirement', e.target.value)}
                >
                  <FormControlLabel 
                    value="first" 
                    control={<Radio />} 
                    label="Make only First Question Required" 
                  />
                  <FormControlLabel 
                    value="all" 
                    control={<Radio />} 
                    label="Make All Questions Required" 
                  />
                </RadioGroup>
              </FormControl>
              
              <Box sx={{ mb: 1 }}>
                <Typography variant="subtitle1" gutterBottom>
                  Question 1
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={1}
                  placeholder="Enter feedback question"
                  value={settings.question1}
                  onChange={(e) => handleChange('question1', e.target.value)}
                  inputProps={{ maxLength: 200 }}
                />
                <Typography variant="caption" color="textSecondary" sx={{ display: 'block', mt: 0 }}>
                  {q1CharsLeft} characters left
                </Typography>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={settings.q1Mandatory}
                      onChange={(e) => handleChange('q1Mandatory', e.target.checked)}
                    />
                  }
                  label="Make mandatory"
                />
                <Typography variant="caption" color="textSecondary" display="block">
                  Answer Format: Long Answer (500 characters)
                </Typography>
              </Box>
              
              <Box sx={{ mb: 1 }}>
                <Typography variant="subtitle1" gutterBottom>
                  Question 2
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={1}
                  placeholder="Enter feedback question"
                  value={settings.question2}
                  onChange={(e) => handleChange('question2', e.target.value)}
                  inputProps={{ maxLength: 200 }}
                />
                <Typography variant="caption" color="textSecondary" sx={{ display: 'block', mt: 0 }}>
                  {q2CharsLeft} characters left
                </Typography>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={settings.q2Mandatory}
                      onChange={(e) => handleChange('q2Mandatory', e.target.checked)}
                    />
                  }
                  label="Make mandatory"
                />
                <Typography variant="caption" color="textSecondary" display="block">
                  Answer Format: Long Answer (500 characters)
                </Typography>
              </Box>
              
              <Divider sx={{ my: 1 }} />
              
              <FormControlLabel
                control={
                  <Checkbox
                    checked={settings.showImmediate}
                    onChange={(e) => handleChange('showImmediate', e.target.checked)}
                  />
                }
                label={`Show questionnaire immediately after ${isLearningPath ? 'Learning Path' : 'Course'} completion`}
              />
            </Box>
          )} */}
        </Box>
      </Paper>      
    </Box>
  );
};

export default DefaultFeedbackSettings;